import * as React from 'react';
export const bizumSvg = React.forwardRef(function bizumSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11.258 13.09c.78.546 1.908.378 2.471-.378l2.082-2.775a1.7 1.7 0 0 0-.39-2.396c-.781-.547-1.908-.378-2.472.378l-2.081 2.775c-.564.756-.39 1.807.39 2.396Zm9.452-3.91c-.78-.546-1.908-.378-2.471.379L9.914 20.615a1.7 1.7 0 0 0 .39 2.396c.78.546 1.908.378 2.471-.379l8.282-11.055a1.656 1.656 0 0 0-.347-2.397Zm-10.233-.882a1.7 1.7 0 0 0-.39-2.396c-.78-.547-1.907-.42-2.471.378-.564.757-.434 1.807.39 2.396.78.546 1.865.378 2.471-.378Zm12.574 15.175c-.78-.546-1.907-.378-2.471.379a1.7 1.7 0 0 0 .39 2.396c.78.546 1.908.378 2.472-.379.563-.756.39-1.807-.39-2.396ZM19.8 19.101c-.78-.546-1.907-.378-2.47.379l-2.082 2.774a1.7 1.7 0 0 0 .39 2.396c.78.547 1.908.379 2.471-.378l2.082-2.775a1.7 1.7 0 0 0-.39-2.396Z',
      fill: '#05C0C7',
    }),
  );
});
bizumSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bizum = {
  category: 'brand',
  colorable: false,
  name: 'bizum',
  svg: bizumSvg,
};
